<template>
    <main>
        <TimeTrackingDashboard />
    </main>
</template>

<script>
import TimeTrackingDashboard from "@/components/TimeTrackingDashboard.vue";

export default {
    name: "App",
    components: {
        TimeTrackingDashboard
    }
}
</script>
